<script lang="ts">
  export let uid = localStorage.getItem('userId')
  import { db } from '../firebase-settings'
  import { doc, updateDoc,getDoc } from "firebase/firestore";
  let bank:string
  let acctNumber: string
  let country: string
  let sortcode: string
  let amount: any

  console.log(uid)

  $:spinner = false

  let requestWithdrawal = async () => {
    spinner = true
    const docRef = doc(db, "plans", uid);
    const docSnap = await getDoc(docRef);
    const user = docSnap.data()
    const { investments } = user
    if(amount > investments[0].roi){
      alert('amount exceeds current profit!')
      return
    }
    investments[0].roi = parseInt(investments[0].roi) - parseInt(amount)
    // console.log(investments, user)
    await updateDoc(doc(db, "plans", uid), {
      withdrawalRequest: true,
      investments
    });
    alert('Withdrawal Request Logged!')
    spinner = false
  }
  let src = 'lpm.png'
</script>

<div class="flex w-full bg-gray-100 items-center justify-center px-4 py-4">
  <div class="w-full max-w-md">
    <form on:submit|preventDefault={requestWithdrawal} class="bg-white shadow-lg rounded-md px-12 pt-6 pb-8 mb-4">
      
      <div class="mb-2">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for=""
        >
          Country
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          name="text"
          type="text"
          required
          bind:value={country}
        />
      </div>
      <div class="mb-2">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="username"
        >
          Bank
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          name="text"
          type="text"
          required
          bind:value={bank}
        />
      </div>
      <div class="mb-2">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="password"
        >
          Account Number
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          placeholder="Password"
          name="password"
          bind:value={acctNumber}
          required
          autocomplete="current-password"
        />
      </div>
      <div class="mb-2">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="password"
        >
          Amount
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          placeholder="Amount"
          name="password"
          bind:value={amount}
          required
          autocomplete="current-password"
        />
      </div>
      <div class="mb-2">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="password"
        >
          Sort Code
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          placeholder="Sort code"
          name="sortCode"
          bind:value={sortcode}
          required
          autocomplete="current-password"
        />
      </div>
      <div class="flex items-center justify-between">
        
        {#if spinner}
          <button class="px-4 py-2 rounded text-white inline-block shadow-lg bg-blue-500 hover:bg-blue-600 focus:bg-blue-700" type="submit">Request Withdrawal 
          <i class="fas fa-spinner ml-2 fa-spin"></i></button>
        {:else}
          <button class="px-4 py-2 rounded text-white inline-block shadow-lg bg-blue-500 hover:bg-blue-600 focus:bg-blue-700" type="submit">Request Withdrawal</button>
        {/if}
      </div>
    </form>
    <p class="text-center text-gray-500 text-xs">
      &copy;2020 Gau Corp. All rights reserved.
    </p>
  </div>
</div>